export default function PricingSection() {
  const inclusions = [
    'Monthly factory visits',
    '48-hour visual reports (photos + video)',
    'Direct WhatsApp access to Lisa',
    'Quality & compliance checks',
    'Worker conditions assessment',
    'Material sourcing verification',
    'Marketing-ready behind-the-scenes content',
    'Cancel anytime',
  ];

  return (
    <section id="pricing" className="py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-8 h-[1px] bg-[#D98C74]"></span>
            <span className="text-[#D98C74] text-[12px] font-semibold tracking-[0.2em] uppercase">
              Investment
            </span>
            <span className="w-8 h-[1px] bg-[#D98C74]"></span>
          </div>
          <h2
            className="text-[30px] lg:text-[40px] font-bold text-[#2C3E50] leading-[1.15] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Simple, Transparent Pricing
          </h2>
          <p className="text-[#2C3E50]/60 text-[16px] leading-[1.7]">
            One monthly fee. No hidden costs.
          </p>
        </div>

        <div className="bg-[#F5F0E6] rounded-lg border border-[#D98C74]/15 overflow-hidden">
          <div className="p-8 lg:p-12">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-10 pb-10 border-b border-[#D98C74]/20">
              <div>
                <div className="text-[12px] text-[#2C3E50]/40 font-semibold tracking-[0.15em] uppercase mb-3">
                  Monthly Retainer
                </div>
                <div className="flex items-baseline gap-2">
                  <span
                    className="text-[52px] lg:text-[60px] font-bold text-[#2C3E50]"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    $1,480
                  </span>
                  <span className="text-[#2C3E50]/40 text-[16px]">/month</span>
                </div>
                <p className="text-[#2C3E50]/55 text-[14px] mt-2">
                  Less than the cost of one flight to China
                </p>
              </div>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-3 bg-[#D98C74] text-white px-10 py-4 rounded-md text-[15px] font-semibold hover:bg-[#c47a62] transition-all whitespace-nowrap cursor-pointer"
              >
                Get Started Now
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {inclusions.map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 bg-[#8A9A5B]/15 rounded-full">
                    <i className="ri-check-line text-[#8A9A5B] text-xs"></i>
                  </div>
                  <span className="text-[#2C3E50]/70 text-[14px]">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#2C3E50] px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/70 text-[14px] text-center sm:text-left">
              <strong className="text-white">$1,480/mo</strong> is a fraction of what a single PR issue could cost your brand.
            </p>
            <a
              href="#contact"
              className="text-[#F2C94C] text-[14px] font-semibold hover:underline cursor-pointer whitespace-nowrap"
            >
              Protect your story &rarr;
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
